import React, { useState } from 'react';

function CTA() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(''); // To show feedback

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Submitting...');
    
    try {
      // Using the actual Formspree form ID provided by the user
      const formId = 'mzzrzkdk'; // Real Formspree form ID
      const response = await fetch(`https://formspree.io/f/${formId}`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 
          email: email,
          source: 'PolitePay Waitlist' 
        })
      });
      
      const json = await response.json();
      
      if (response.ok) {
        setStatus('Success! We\'ll notify you soon.');
        // Optionally clear the email field on success
        // setEmail('');
      } else {
        throw new Error(json.error || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setStatus(`Error: ${error.message || 'Something went wrong. Please try again.'}`);
    }
  };

  return (
    <section id="cta" className="py-16 md:py-20 lg:py-28 bg-white border-t border-gray-100">
      <div className="container mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl sm:text-3xl font-bold mb-4 md:mb-6 text-primary">Be the First to Know When We Launch!</h2>
        <p className="max-w-xl mx-auto mb-4 text-primary-light">Join the waitlist for exclusive early access and a special launch discount. No spam, promise.</p>
        
        {/* Added Incentives - wrap on mobile */}
        <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-8 md:mb-10">
          <span className="inline-block px-3 py-1 bg-accent/10 text-accent text-xs font-semibold rounded-full">50% off for early adopters</span>
          <span className="inline-block px-3 py-1 bg-accent/10 text-accent text-xs font-semibold rounded-full">14-day extended trial</span>
        </div>
        
        <form onSubmit={handleSubmit} className="max-w-lg mx-auto">
          <div className="flex flex-col sm:flex-row gap-3">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              aria-label="Email address"
              className="flex-grow px-4 sm:px-5 py-3 rounded-md text-primary placeholder-primary-light/50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent"
              disabled={status.startsWith('Success')}
            />
            <button
              type="submit"
              className={`px-6 sm:px-8 py-3 rounded-md font-semibold text-center transition duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 
                         ${status.startsWith('Success') 
                           ? 'bg-green-500 text-white cursor-not-allowed' 
                           : 'bg-accent text-white hover:bg-accent-light focus:ring-accent'}`}
              disabled={status.startsWith('Success') || status === 'Submitting...'}
            >
              {status === 'Submitting...' ? 'Sending...' : (status.startsWith('Success') ? 'Subscribed!' : 'Notify Me!')}
            </button>
          </div>
          {status && !status.startsWith('Success') && status !== 'Submitting...' && 
            <p className="mt-4 text-sm text-red-500">{status}</p>
          } 
          {status.startsWith('Success') && 
            <p className="mt-4 text-sm text-accent">{status}</p>
          }
          <p className="mt-4 md:mt-6 text-xs text-primary-light/70">Join 30+ early subscribers. No credit card required.</p>
        </form>
      </div>
    </section>
  );
}

export default CTA; 